import { makeStyles } from '@material-ui/core';
import { LoadingStatus } from './util/useImageProps.js';

var getAvatarDimensions = function (theme, props) {
    var factors = {
        'extra-small': 3,
        small: 4,
        medium: 5,
        large: 6,
        'extra-large': 12.5,
    };
    var sizeFactor = factors[props.size || 'medium'];
    return theme.spacing(sizeFactor);
};
var getAvatarFontSize = function (props) {
    var fontSizes = {
        'extra-small': '0.75rem',
        small: '1rem',
        medium: '1rem',
        large: '1.25rem',
        'extra-large': '3.5rem',
    };
    return fontSizes[props.size];
};
var useAvatarStyles = makeStyles(function (theme) { return ({
    root: function (props) { return ({
        width: getAvatarDimensions(theme, props),
        height: getAvatarDimensions(theme, props),
        fontSize: getAvatarFontSize(props),
        backgroundColor: props.loaded === LoadingStatus.LOADED ? 'transparent' : props.background,
        color: theme.palette.getContrastText(props.background),
        objectFit: props.fit,
    }); },
    fallback: function (props) { return ({
        fontSize: getAvatarDimensions(theme, props),
        strokeWidth: 1,
    }); },
}); });

export { useAvatarStyles };
//# sourceMappingURL=avatar.styles.js.map
